"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const booleanAttributes = new Set([
    'allowfullscreen',
    'async',
    'autofocus',
    'autoplay',
    'checked',
    'controls',
    'default',
    'defer',
    'disabled',
    'disablepictureinpicture',
    'disableremoteplayback',
    'formnovalidate',
    'hidden',
    'itemscope',
    'loop',
    'multiple',
    'muted',
    'nomodule',
    'novalidate',
    'open',
    'playsinline',
    'readonly',
    'required',
    'reversed',
    'scoped',
    'seamless',
    'selected'
]);
exports.default = booleanAttributes;
